@if (floatMenuIsReadyAndNotEmpty()) {
  <div [class.editor-opened]="!readMode" class="d-flex">
    @if (host === 'sidebar-nav') {
      @if (showSplitButton && hasCourseWritingRights()) {
        <app-split-button
          [mainItem]="mainSplitButtonAction"
          [menuItems]="splitButtonMenuItems"
          [buttonId]="'addLectureOrSection'"
          (mainActionClick)="onSplitMenuItemClick($event)"
          (menuItemClick)="onSplitMenuItemClick($event)"
        ></app-split-button>
      } @else if (compact && createButton()) {
        <button type="button" matMiniFab color="primary" (click)="createButton().func()" [hasRole]="['Admin', 'Writer']" [hasRoleAction]="'hide'">
          <mat-icon>{{ createButton().icon }}</mat-icon>
        </button>
      } @else if (createButton()) {
        <button type="button" mat-flat-button color="primary" (click)="createButton().func()" [hasRole]="['Admin', 'Writer']" [hasRoleAction]="'hide'">
          <mat-icon>{{ createButton().icon }}</mat-icon>
          {{ createButton().translateKey | translate }}
        </button>
      }
    } @else {
      @if (floatMenuItems?.['sync-content'] && syncContentDisplay === 'icon') {
        <button type="button" btnType="action-icon" class="me-2" mat-icon-button (click)="syncContent()" [disabled]="isSyncing()" [matTooltip]="'Global.HardReload' | translate">
          @if (isSyncing()) {
            <mat-icon class="spinning">progress_activity</mat-icon>
          } @else {
            <mat-icon>sync</mat-icon>
          }
        </button>
      }
      @if (floatMenuItems?.['search'] && searchDisplay === 'icon' && !below992) {
        <button type="button" btnType="action-icon" class="me-2" mat-icon-button (click)="openSearchDialog()" [disabled]="isCallInProgress()" [matTooltip]="'Global.Search' | translate">
          <mat-icon>search</mat-icon>
        </button>
      }
      @if (floatMenuItems?.['ai-assistant'] && aiAssistantDisplay === 'icon' && !below600) {
        <app-generate-content class="me-2" [displayMode]="'icon'" [disabled]="isCallInProgress()" (clicked)="openAIPane()" />
      }
      <button type="button" mat-icon-button [matMenuTriggerFor]="optionsMenu">
        <mat-icon>more_horiz</mat-icon>
      </button>
    }
  </div>
}

<mat-menu #optionsMenu="matMenu" xPosition="before" class="skz-premium-menu">
  @for (group of getGroupedMenuItems(); track group.titleKey; let isFirstGroup = $first) {
    @if (!isFirstGroup) {
      <mat-divider class="menu-section-divider"></mat-divider>
    }
    @if (group.titleKey) {
      <div class="menu-section-header">{{ group.titleKey | translate }}</div>
    }
    @for (item of group.items; track item.key) {
      @if (item.submenu && item.submenu.length > 0) {
        <button class="menu-section-btn" mat-menu-item [matMenuTriggerFor]="exportMenu" [disabled]="isCallInProgress() && item.key !== 'start-call' && item.key !== 'copy-content'">
          @if (item.icon) {
            <mat-icon>{{ getMenuItemIcon(item) }}</mat-icon>
          }
          <span>{{ getMenuItemLabel(item) | translate }}</span>
        </button>
      } @else {
        <button class="menu-section-btn" mat-menu-item (click)="handleItemClick(item.actionKey, item.actionParam, $event)" [disabled]="isCallInProgress() && item.key !== 'start-call' && item.key !== 'copy-content'">
          @if (item.icon) {
            <mat-icon>{{ getMenuItemIcon(item) }}</mat-icon>
          }
          <span>{{ getMenuItemLabel(item) | translate }}</span>
        </button>
      }
    }
  }
</mat-menu>

<mat-menu #exportMenu="matMenu" class="skz-premium-menu">
  @for (subItem of getExportSubmenuItems(); track subItem.key) {
    <button class="menu-section-btn" mat-menu-item (click)="handleItemClick(subItem.actionKey, subItem.actionParam, $event)">
      @if (subItem.icon) {
        <mat-icon>{{ subItem.icon }}</mat-icon>
      }
      <span>{{ subItem.tooltipKey | translate }}</span>
    </button>
  }
</mat-menu>
